const FORMAT_LABELS: Record<string, string> = {
  "application/json": "JSON",
  "application/yaml": "YAML",
  "text/html": "HTML",
  "text/markdown": "Markdown",
  "text/plain": "Text",
};

export const formatLabel = (mediaType: string): string => FORMAT_LABELS[mediaType] ?? mediaType;

export const MADE_UP_NOTE = "The IDs and the values are made up, to show the format.";

/** An example as the file would show it: text as it is, JSON indented. */
export const exampleText = (example: unknown): string =>
  typeof example === "string" ? example : JSON.stringify(example, null, 2);
